import '../../components/Note/Note.css'
import React from 'react'
import Draggable from '../Draggable';

import quarterNoteBox from '../../assets/quarterNoteBox.png'

const QuarterNote = () => {

    return (
        <Draggable>
            <img 
                className="note quarter" 
                src={quarterNoteBox} 
                alt="quarter note" 
            />
        </Draggable>
    )
}

export default QuarterNote